// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "./CSS.bs.js";
function string_of_entry(entry) {
  return entry._0;
}
function color_of_entry(entry) {
  switch (entry.TAG | 0) {
    case /* Log */0:
      return "text-white";
    case /* Error */1:
      return "text-red-500";
    case /* Info */2:
      return "text-blue-500";
    case /* Warn */3:
      return "text-yellow-500";
  }
}
function Debugger$Entry(Props) {
  var entry = Props.entry;
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["whitespace-nowrap", color_of_entry(entry)]))
  }, entry._0);
}
Debugger$Entry.displayName = "Debugger.Entry";
var Entry = {
  make: Debugger$Entry
};
function Debugger(Props) {
  var anchorOpt = Props.anchor;
  var positionOpt = Props.position;
  var logs = Props.logs;
  var enabledOpt = Props.enabled;
  var className = Props.className;
  var children = Props.children;
  var anchor = anchorOpt !== undefined ? anchorOpt : "left";
  var position = positionOpt !== undefined ? positionOpt : "absolute";
  var enabled = enabledOpt !== undefined ? enabledOpt : false;
  var renderLogs = function (param) {
    return Belt_Array.mapWithIndex(logs, function (i, log) {
      return React.createElement(Debugger$Entry, {
        entry: log,
        key: String(i)
      });
    });
  };
  var children$1 = Belt_Option.getWithDefault(children, null);
  var className$1 = Belt_Option.getWithDefault(className, CSS$Showside.prefix("absolute inset-0 pointer-events-none"));
  if (enabled) {
    return React.createElement("div", {
      className: className$1
    }, children$1, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["z-max text-xl bg-black text-white flex flex-col space-y-1", position === "fixed" ? "fixed" : "absolute", anchor === "middle" ? "top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2" : anchor === "bottom" ? "bottom-0" : anchor === "right" ? "top-0 right-0" : "top-0 left-0"]))
    }, renderLogs(undefined)));
  } else {
    return children$1;
  }
}
Debugger.displayName = "Debugger";
var make = Debugger;
export { string_of_entry, color_of_entry, Entry, make };
/* react Not a pure module */